import { Link } from 'react-router-dom';
import { DraftingCompass, FileBadge, FileSearch, Building2, Zap, HardHat, Scale, PanelsTopLeft, ArrowUpRight } from 'lucide-react';

const ICONS = {
  drafting: DraftingCompass,
  fileBadge: FileBadge,
  fileSearch: FileSearch,
  building: Building2,
  zap: Zap,
  hardHat: HardHat,
  scale: Scale,
  panels: PanelsTopLeft,
};

export default function ServiceCard({ service, detailed = false, className = '' }) {
  const Icon = ICONS[service.icon] || Building2;
  return (
    <article
      className={`group card-hover relative flex h-full flex-col overflow-hidden rounded-2xl surface p-7 ${className}`}
      data-testid={`service-card-${service.id}`}
    >
      <span className="outline-numeral pointer-events-none absolute -right-2 -top-5 select-none font-display text-7xl font-extrabold" aria-hidden="true">
        {String(service.id).padStart(2, '0')}
      </span>
      <div className="grid h-12 w-12 place-items-center rounded-xl bg-navy text-gold-light transition-colors duration-300 group-hover:bg-gold group-hover:text-navy-deep dark:bg-white/10">
        <Icon size={22} strokeWidth={1.8} />
      </div>
      <p className="mt-5 text-[11px] font-bold uppercase tracking-[0.2em] text-azure dark:text-gold-light">{service.category}</p>
      <h3 className="mt-2 font-display text-lg font-bold leading-snug text-navy dark:text-white">{service.name}</h3>
      <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-c">{service.shortDescription}</p>
      {detailed && <p className="mt-3 text-sm leading-relaxed text-muted-c border-t border-line pt-3">{service.detailedDescription}</p>}
      <div className="mt-5 flex flex-wrap gap-2">
        {service.norms.map((n) => (
          <span key={n} className="chip">{n}</span>
        ))}
      </div>
      <Link
        to={`/simulador?demanda=${encodeURIComponent(service.demand)}`}
        onClick={(e) => e.stopPropagation()}
        data-testid={`service-simulate-${service.id}`}
        className="mt-5 inline-flex items-center gap-1.5 font-display text-[11px] font-bold uppercase tracking-wider text-azure transition-colors hover:text-gold dark:text-gold-light dark:hover:text-gold"
      >
        Simular este serviço <ArrowUpRight size={13} />
      </Link>
      <span className="absolute bottom-0 left-0 h-1 w-0 bg-gold transition-all duration-500 group-hover:w-full" aria-hidden="true" />
      <ArrowUpRight size={16} className="absolute right-5 top-5 text-gold opacity-0 transition-all duration-300 group-hover:opacity-100" aria-hidden="true" />
    </article>
  );
}
